import * as yup from 'yup';

const prizesSchema = yup.object().shape({
  startsAt: yup.string().required(),
  endsAt: yup.string().required(),
  prizes: yup.array().of(yup.string().required('Prize is required')),
});

export default prizesSchema;
